import { useCallback, useEffect, useState } from "react";
import { Activity, RefreshCcw, Square } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

const dur = (s) => (s < 60 ? `${s} dtk` : s < 3600 ? `${Math.floor(s / 60)} mnt ${s % 60} dtk` : `${Math.floor(s / 3600)} jam ${Math.floor((s % 3600) / 60)} mnt`);

export function BgTasksCard() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");
  const load = useCallback(() => api.get("/system/bg-tasks").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);
  const stop = async (t) => {
    if (!window.confirm(`Hentikan proses "${t.name}"?`)) return;
    setBusy(t.id);
    try { const { data } = await api.post(`/system/bg-tasks/${t.id}/stop`); toast.success(`Dihentikan: ${data.stopped}`); load(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const tasks = data?.tasks || [];
  return (
    <Card className="bg-card border-border shadow-sm" data-testid="settings-bg-tasks-card">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-base flex items-center gap-2"><Activity className="w-4 h-4 text-sky-500" /> Proses Latar Belakang <span className="text-xs font-mono text-muted-foreground">({tasks.length} berjalan)</span></CardTitle>
        <Button size="sm" variant="ghost" onClick={load} data-testid="bg-tasks-refresh"><RefreshCcw className="w-4 h-4" /></Button>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-xs text-muted-foreground">Proses massal yang sedang berjalan di server (pulihkan semua cabang, scan voucher per jam, backup, cetak voucher, dll). Diperbarui tiap 5 detik. Server: <span className="font-mono">{data?.instance || "-"}</span>.</p>
        {data && !tasks.length && <div className="text-sm text-muted-foreground rounded-lg border border-dashed border-border p-3 text-center" data-testid="bg-tasks-empty">Tidak ada proses latar belakang yang sedang berjalan.</div>}
        {tasks.map((t) => (
          <div key={t.id} className="flex items-center gap-3 rounded-lg border border-border px-3 py-2" data-testid={`bg-task-${t.id}`}>
            <span className="relative flex h-2.5 w-2.5 shrink-0"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-sky-500" /></span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium truncate">{t.name}{t.detail ? <span className="text-muted-foreground font-normal"> — {t.detail}</span> : null}</div>
              <div className="text-[11px] text-muted-foreground font-mono">berjalan {dur(t.running_sec)}{t.who ? ` · oleh ${t.who}` : " · otomatis (cron)"}</div>
            </div>
            <Button size="sm" variant="outline" className="border-rose-500/40 text-rose-500 hover:bg-rose-500/10 shrink-0" disabled={!t.cancellable || busy === t.id} title={t.cancellable ? "Hentikan proses" : "Tidak boleh dihentikan paksa (menjaga konsistensi saldo/voucher)"} onClick={() => stop(t)} data-testid={`bg-task-stop-${t.id}`}>
              <Square className="w-3.5 h-3.5 mr-1" /> Hentikan
            </Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
